import api from 'config/api/api';
import { apiRoutes } from 'config/api/apiRoutes';
import { IConfiguration, ICountryLookup, ILanguageLookup, ITimezoneLookup } from 'models/commonModel';

export async function getAppSettings(): Promise<IConfiguration[]> {
    return api.get('AppConfiguration/GetConfigurations')
        .then(response => response.data)
        .catch(error => { throw error });
}

export async function validateUrl(url: string, validContentTypes?: string[], signal?: AbortSignal): Promise<boolean> {
    const data = {
        url,
        validContentTypes
    }
    return api.post(apiRoutes.validateUrl, data, { signal })
        .then(response => response.data)
}

export const useCommonApi = () => {

    async function getCountriesList(): Promise<ICountryLookup[]> {
        return api.get(apiRoutes.getCountries)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getLanguagesList(): Promise<ILanguageLookup[]> {
        return api.get(apiRoutes.getLanguages)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getTimezonesList(): Promise<ITimezoneLookup[]> {
        return api.get(apiRoutes.getTimezones)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    return { getCountriesList, getLanguagesList, getTimezonesList }
}